const subLedger = {
  path: 'subLedger',
  component: resolve => require(['../../../../../../pages/admin/reviewed/wechat/subLedger'], resolve),
  meta: {isSubLedger: true}
}

export default subLedger
